// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-license-wrapper {
  background-color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}
@media (min-width: 1200px) {
  .ultimate-security-license-wrapper {
    margin-left: 350px;
    margin-right: 350px;
  }
}
.ultimate-security-license-wrapper ol {
  margin-left: 16px;
  padding-left: 16px;
}
.ultimate-security-license-wrapper .green-text {
  color: #28A745;
}
.ultimate-security-license-wrapper .license-status {
  display: inline-block;
  padding: 8px 12px;
  background-color: #EBEBF4;
  border-radius: 50rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ultimate-security-license-wrapper .license-status::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #873EFF;
}`, "",{"version":3,"sources":["webpack://./src/pages/License/License.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAAI;EANJ;IAOQ,kBAAA;IACA,mBAAA;EAGN;AACF;AAFI;EACI,iBAAA;EACA,kBAAA;AAIR;AAFI;EACI,cAAA;AAIR;AAFI;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAIR;AAHQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAKZ","sourcesContent":[".ultimate-security-license-wrapper {\n    background-color: #ffffff;    \n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #000000;\n    @media (min-width: 1200px) {\n        margin-left: 350px;\n        margin-right: 350px;        \n    }\n    ol {\n        margin-left: 16px;\n        padding-left: 16px;\n    }\n    .green-text {\n        color: #28A745;\n    }\n    .license-status {\n        display: inline-block;\n        padding: 8px 12px;\n        background-color: #EBEBF4;\n        border-radius: 50rem;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        &::before {\n            content: '';\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            display: inline-block;\n            background-color: #873EFF;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
